module.exports = __webpack_public_path__ + "static/WhatsApp Image 2020-09-07 at 3.53.03 PM (3)-bd47a7c652e4146c2fa171e55e6298ca.jpeg";